import type { FundModel } from '../../../../types';
import axios from '../../../api-client.ts';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextareaAutosize from 'react-textarea-autosize';
import { KTIcon } from '../../../../_mesomb/helpers';
import Message, { type FundMessage } from '../../fund/components/Message.tsx';

function FundMessages({ fund }: { fund: FundModel }) {
  const [messages, setMessages] = useState<FundMessage[]>([]);
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const { t } = useTranslation();
  const onSend = (e: React.FormEvent) => {
    e.preventDefault();
    setSending(true);
    axios
      .post(`/fund/contribute/${fund.slug}/messages/`, { content: message })
      .then(({ data }) => {
        setMessages([...messages, data]);
        setMessage('');
        setSending(false);
      })
      .catch((e) => {
        setSending(false);
        console.error(e);
      });
  };
  const fetchMessages = () => {
    axios
      .get(`/fund/contribute/${fund.slug}/messages/`)
      .then(({ data }) => {
        setMessages(data.data);
      })
      .catch((e) => {
        console.error(e);
      });
  };
  useEffect(() => {
    fetchMessages();
  }, []);
  return (
    <>
      {messages.map((message, index) => (
        <Message key={index} message={message} />
      ))}

      {/* begin::Separator */}
      <div className='separator mb-4'></div>
      {/* end::Separator */}

      {/* begin::Reply input */}
      <form className='position-relative mb-6'>
        <TextareaAutosize
          className={'form-control border-0 p-0 pe-10 resize-none min-h-25px'}
          placeholder={t('Leave a message')}
          onChange={(e) => setMessage(e.target.value)}
          value={message}
        />

        <div className='position-absolute top-0 end-0 me-n5'>
          <button
            onClick={onSend}
            className='btn btn-icon btn-sm btn-active-color-primary pe-0 me-2'
          >
            {sending ? (
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            ) : (
              <KTIcon iconName='send' className='fs-3 mb-3' />
            )}
          </button>
        </div>
      </form>
      {/* edit::Reply input */}
    </>
  );
}

export default FundMessages;
